/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Import_Source_Pane_LabelInputs */



/**
* | output |
* | --- |
* | "Source File" |
*
* @param {Translation_Import_Source_Pane_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_import_source_pane_label = /** @type {((inputs?: Translation_Import_Source_Pane_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Import_Source_Pane_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fichier source")
	if (locale === "de") return /** @type {LocalizedString} */ ("Quelldatei")
	if (locale === "it") return /** @type {LocalizedString} */ ("File sorgente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Исходный файл")
	if (locale === "es") return /** @type {LocalizedString} */ ("Archivo fuente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("源文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ソースファイル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्रोत दस्तावेज")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Arquivo de origem")
	return /** @type {LocalizedString} */ ("Source File")
});